export class Contact {
  participantId: number | null;
  energyType?: 'consumer' | 'producer' | null;
  name: string;
  mail: string;

  constructor(participantId: number | null, name: string, mail: string, energyType?: 'consumer' | 'producer' | null) {
    this.participantId = participantId;
    this.energyType = energyType;
    this.name = name;
    this.mail = mail;
  }
}
